module.exports = __webpack_public_path__ + "first-20_uv.jpg?17510308088e0c17ecfa71730ae4e42f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_uv.jpg
// module id = 507
// module chunks = 0